export default __webpack_public_path__ + "static/media/empleoscuscofirst.ab575ec8.png";